@if (facade.isExpandedViewActive()) {
  <div class="ratings-expanded-view">
      <div class="content-container">
        <header>
          <topo-ratings-location-display [document]="facade.selectedOverviewDocument()" />
          <i
            class="icon icon-close-X close-button"
            (click)="hideExpandedView()"></i>
        </header>
        <div class="content">
          <aside>
            <topo-ratings-intelligence-header
              [document]="facade.selectedOverviewDocument()"
              [showDivider]="false"
              isForExpandedView />
            @if (overviewNode()?.children?.length) {
              <div class="divider"></div>
              <div class="overview-document-details">
                @for (node of overviewNode().children; track node.id) {
                  <div>
                    <label>{{ node.document.category_tag }}</label>
                    <div
                      class="overview-document-content"
                      [innerHTML]="node.document.intel"></div>
                  </div>
                }
              </div>
            }
          </aside>
          <section>
            @if (!facade.loading()) {
              <img
                class="flag-banner"
                [style.height]="hideFlagBanner ? 0 : 'inherit'"
                [src]="flagBannerImgSrc() | async | safeUrl"
                (load)="hideFlagBanner = false"
                (error)="hideFlagBanner = true" />
              <div class="category-tabs">
                <div class="tab-container">
                  @for (tab of categoryTabs(); track tab.rank) {
                    @let isSelected = selectedTabIndex() === $index;
                    <div
                      class="tab"
                      [class.is-selected]="isSelected"
                      (click)="handleTabChanged($index); dynamicContent.scrollTop = 0">
                      <topo-horizon-category-rank-icon
                        [rank]="tab.rank"
                        [size]="20"
                        [color]="isSelected ? 'var(--neutral-color-900)' : 'var(--neutral-color-600)'" />
                      <span>{{ tab.label }}</span>
                    </div>
                  }
                </div>
              </div>

              <div
                class="dynamic-content"
                #dynamicContent>
                <ng-container *ngTemplateOutlet="selectedTabIndex() === 0 ? overviewDetails : categoryDetails" />
              </div>
            }
          </section>
        </div>
      </div>
  </div>
}
<ng-template #overviewDetails>
  @let node = selectedDocumentNode();
  <div class="overview-details">
    <div class="card">
      <div class="card-header">
        <span class="text is-bolder">{{ node.document.category_tag }}</span>
        <topo-ratings-bar
          horizontal
          small
          [label]="selectedNodeRatingText()"
          [value]="node.document.custom_rating_number ?? node.document.rating_number" />
      </div>
      <div
        class="overview-document-content pt-4"
        [innerHTML]="node.document.intel"></div>
    </div>

    <div class="card-grid">
      @for (categoryNode of topLevelCategoryNodes(); track categoryNode.id) {
        <div class="card">
          <topo-ratings-bar
            largeLabel
            [categoryRank]="categoryNode.document.rank"
            [label]="categoryNode.document.category_tag"
            [value]="categoryNode.document.custom_rating_number ?? categoryNode.document.rating_number" />
          <div class="divider"></div>
          <div class="card-body">
            @for (childCategoryNode of categoryNode.children; track childCategoryNode.id) {
              <topo-ratings-bar
                tiny
                [label]="childCategoryNode.document.category_tag"
                [value]="childCategoryNode.document.custom_rating_number ?? childCategoryNode.document.rating_number" />
            }
          </div>
        </div>
      }
    </div>
  </div>
</ng-template>

<ng-template #categoryDetails>
  @let node = selectedDocumentNode();
  <div class="category-details">
    <div class="card">
      <div class="card-header">
        <span class="text is-bolder">{{ node.document.category_tag }}</span>
        <topo-ratings-bar
          horizontal
          small
          [label]="selectedNodeRatingText()"
          [value]="node.document.custom_rating_number ?? node.document.rating_number" />
      </div>
      <div
        class="overview-document-content pt-4"
        [innerHTML]="node.document.intel"></div>
    </div>

    @for (node of selectedDocumentNode().children; track node.id) {
      <topo-ratings-document-card [node]="node" />
    }
  </div>
</ng-template>
